<script lang="ts" setup>

//vue
import { onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/clientesService";
import * as contratosService from "@/services/clientesContratosService";
import { useAcl } from "vue-simple-acl";
const acl = useAcl();


//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";
import AutoCompleteClientes from "@/components/AutoCompletes/AutoCompleteClientes.vue";
import Dependentes from "./ClientesDependentes.vue";
import Documentos from "./ClientesDocumentos.vue";
import Contratos from "./ClientesContratos.vue";
import Vouchers from "./ClientesVouchers.vue";
import MsgBox from "@/components/MsgBox/Index.vue";

import { fdataHora, isoParaData } from "@/utils/funcoes";

const route = useRoute();

var controle = reactive({

  model: {

  } as service.Cliente,
  tipos: ['Familiar', 'Empresarial'],
  simNao: [
    { texto: 'SIM', valor: true },
    { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],
  podeGravar: true,
  podeCartao: true,
  erro: "",
  status: "",

  janAlterarSenha: false,
  formSenha: {
    senhaNova: '',
    confirmaNovaSenha: '',
  },
})

onMounted(() => {

  console.log("buscar")
  if (route.params.id) {
    // Se houver um ID na rota, buscar os detalhes do usuário
    service.obterPorId(Number(route.params.id))
      .then(async r => {
        controle.model = r;
        await buscarContratos();
      })
      .catch(error => {
        controle.erro = `Erro ao carregar: ${error}`;
      });
  }

  setTimeout(() => {
    var el = document.getElementById("inputFocus");
    if (el) {
      el.focus();
    }
  }, 500);

});

async function buscarContratos() {
  try {
    controle.status = "Buscando contratos...";
    controle.erro = "";
    const contratos = await contratosService.obter({ clienteId: controle.model.clienteId } as contratosService.Filtros);

    var contratosSemAssinar = contratos.filter(c => c.dataAssinatura == null == null);

    if (acl.can('supervisor') || acl.can('admin')) {
      controle.podeGravar = true;
    }
    else {
      controle.podeGravar = acl.can('vendedor') && (contratosSemAssinar.length > 0);
    }

    if (acl.can('supervisor') || acl.can('admin')) {
      controle.podeCartao = (contratosSemAssinar.length == 0);
    }

    controle.status = "";
  } catch (error) {
    controle.erro = `Erro ao buscar contratos: ${error}`;
    controle.status = "";
  }
}

async function salvar() {
  try {
    // 1. Salvar o registro primeiro
    controle.status = "Salvando...";
    controle.erro = "";

    // if (controle.model.dataNascimento != null && controle.model.dataNascimento != "") {
    //   controle.model.dataNascimento = isoParaData(controle.model.dataNascimento);
    // }

    const resultado = await service.salvar(controle.model)
    
    controle.model = resultado;

    controle.status = "Salvo com sucesso!";
    setTimeout(() => {
      controle.status = "";
    }, 3000);
  } catch (error) {
    controle.erro = `Erro ao salvar: ${error}...`;
    return;
  }
}

async function cartao() {
  try {
    //abrir a pagina do cartao em outra aba
    const url = `/clientes/cartao/${controle.model.clienteId}`;
    window.open(url, '_blank');

  } catch (error) {
    controle.erro = `Erro ao abrir cartão: ${error}...`;
    return;
  }
}

function abrirAlterarSenha() {
  controle.formSenha.senhaNova = '';
  controle.formSenha.confirmaNovaSenha = '';
  controle.janAlterarSenha = true;
}

function confirmarAlterarSenha() {
  controle.status = "Alterando senha...";
  controle.erro = "";
  service.alterarSenha(
    controle.model.clienteId,
    controle.formSenha.senhaNova,
    controle.formSenha.confirmaNovaSenha
  )
    .then(() => {
      controle.status = "Senha alterada com sucesso!";
      setTimeout(() => {
        controle.janAlterarSenha = false;
        controle.status = "";
      }, 3000);
    })
    .catch(erro => {
      controle.erro = erro;
      controle.status = "";
    });
}
</script>

<template>
  <BreadCrumb PageTitle="Cadastro de Clientes" :items="[
    { label: 'Clientes', to: '/clientes' },
    { label: 'Cadastro', to: '/clientes/cadastro' }]" />

  <Notificacao :erro="controle.erro" @limparErro="controle.erro = ''" :progresso="controle.status"
    @limparProgresso="controle.status = ''" />

  <TrataTecla>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
      <div class="card-body p-4">
        <div class="row">

          <!-- coluna 1-->
          <div class="col-md-6">
            <div class="row mb-2">
              <div class="col-md-3">
                <label for="clienteId" class="form-label">ID</label>
              </div>
              <div class="col-md-3">
                <TextBox v-model="controle.model.clienteId" id="clienteId" :formato="'Numero'" readonly disabled />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="nome" class="form-label obrigatorio">Nome</label>
              </div>
              <div class="col-md-9">
                <TextBox v-model="controle.model.nome" id="inputFocus" :formato="'Maiusculo'" />
              </div>
            </div>


            <div class="row mb-2">
              <div class="col-md-3">
                <label for="cpf" class="form-label">CPF</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.cpf" id="cpf" :formato="'CpfCnpj'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="rg" class="form-label">RG</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.rg" id="rg" :formato="'Texto'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="rgExpedidor" class="form-label">RG Expedidor</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.rgExpedidor" id="rgExpedidor" :formato="'Texto'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="telefone" class="form-label">Telefone</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.telefone" id="telefone" :formato="'Telefone'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="celular" class="form-label">Celular</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.celular" id="celular" :formato="'Telefone'" class="" />
              </div>
            </div>


            <div class="row mb-2">
              <div class="col-md-3">
                <label for="logradouro" class="form-label">Logradouro</label>
              </div>
              <div class=col-md-7>
                <TextBox v-model="controle.model.logradouro" id="logradouro" :formato="'Maiusculo'" class="" />
              </div>

              <div class=col-md-2>
                <TextBox v-model="controle.model.numero" id="numero" :formato="'Maiusculo'" class="" placeholder="Número" />
              </div>
            </div>


            <div class="row mb-2">
              <div class="col-md-3">
                <label for="bairro" class="form-label">Bairro</label>
              </div>
              <div class=col-md-9>
                <TextBox v-model="controle.model.bairro" id="bairro" :formato="'Maiusculo'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="cidadeId" class="form-label">Cidade</label>
              </div>
              <div class=col-md-9>
                <AutoCompleteCidade v-model="controle.model.cidadeId" id="cidadeId" />
              </div>
            </div>


            <div class="row mb-2">
              <div class="col-md-3">
                <label for="cep" class="form-label">CEP</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.cep" id="cep" :formato="'Cep'" class="" />
              </div>
            </div>


          </div>

          <!-- coluna 2-->
          <div class="col-md-6">




            <div class="row mb-2">
              <div class="col-md-3">
                <label for="complemento" class="form-label">Complemento</label>
              </div>
              <div class=col-md-9>
                <TextBox v-model="controle.model.complemento" id="complemento" :formato="'Maiusculo'" class="" />
              </div>
            </div>


            <div class="row mb-2">
              <div class="col-md-3">
                <label for="dataNascimento" class="form-label">Data Nascimento</label>
              </div>
              <div class=col-md-4>
                <TextBox :formato="'Data'" v-model="controle.model.dataNascimento" id="dataNascimento"  />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="email" class="form-label">Email</label>
              </div>
              <div class=col-md-9>
                <TextBox v-model="controle.model.email" id="email" :formato="'email'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="nomeConjuge" class="form-label">Nome Cônjuge</label>
              </div>
              <div class=col-md-9>
                <TextBox v-model="controle.model.nomeConjuge" id="nomeConjuge" :formato="'Maiusculo'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="cpfConjuge" class="form-label">CPF Cônjuge</label>
              </div>
              <div class=col-md-6>
                <TextBox v-model="controle.model.cpfConjuge" id="cpfConjuge" :formato="'CpfCnpj'" class="" />
              </div>
            </div>


            <div class="row mb-2">
              <div class="col-md-3">
                <label for="observacoes" class="form-label">Observações</label>
              </div>
              <div class=col-md-9>
                <TextBox v-model="controle.model.observacoes" id="observacoes" :formato="'Texto'" class="" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="ativo" class="form-label">Cortesia</label>
              </div>
              <div class=col-md-4>
                <select v-model="controle.model.cortesia" id="cortesia" class="form-select form-select-sm">
                  <option v-for="tipo in controle.simNao" :key="String(tipo.valor)" :value="tipo.valor">{{ tipo.texto }}
                  </option>
                </select>
              </div>
            </div>

            <!-- 
              <div class="row mb-2">
                <div class="col-md-3">
                  <label for="senha" class="form-label">Senha</label>
                </div>
                <div class=col-md-6>
                  <TextBox v-model="controle.model.senha" id="senha"  :formato="'password'" class=""/>
                </div>
              </div> -->

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="clienteIndicou" class="form-label">Cliente indicou</label>
              </div>
              <div class=col-md-9>
                <AutoCompleteClientes v-model="controle.model.clienteIndicouId" id="clienteIndicou" />
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-3">
                <label for="ativo" class="form-label">Ativo</label>
              </div>
              <div class=col-md-4>
                <select v-model="controle.model.ativo" id="ativo" class="form-select form-select-sm">
                  <option v-for="tipo in controle.simNao" :key="String(tipo.valor)" :value="tipo.valor">{{ tipo.texto }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row mb-2" v-if="controle.model.usuario">
              <div class="col-md-3">
                <label for="cadastradoPor" class="form-label">Cadastrado por</label>
              </div>
              <div class=col-md-9>
                <TextBox v-model="controle.model.usuario.nomeCompleto" id="cadastradoPor" :formato="'Texto'" class=""
                  readonly="readonly" />
              </div>

            </div>

            <div class="row" v-if="controle.model.usuario">
              <div class="col-md-3">
                <label for="cadastradoPor" class="form-label">Dt Cadastro</label>
              </div>
              <div class=col-md-6>
                <input type="text" :value="fdataHora(controle.model.dataCadastro)" id="dataCadastro"
                  class="form-control form-control-sm " readonly="true" />
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class='card-footer'>
        <div class="row">
          <div class="col-md-2">
            <a class="btn btn-sm btn-primary" @click="salvar()" v-if="controle.podeGravar">Gravar</a>
          </div>


          <div class="col-md-4">
            <div v-if="controle.erro == null && controle.status != null" class="fw-bold">{{ controle.status }}</div>
            <div v-if="controle.erro != null" class="fw-bold text-danger">{{ controle.erro }}</div>
          </div>

          <div class="col-md-4">
            <a class="btn btn-sm btn-success me-2" @click="cartao()" v-if="controle.podeGravar">Imprimir Cartão</a>
            <a class="btn btn-sm btn-warning" @click="abrirAlterarSenha()" v-if="controle.model.clienteId">Alterar
              Senha</a>
          </div>

          <div class="col-md-2">
            <RouterLink class="btn btn-sm btn-secondary float-end" :to="'/clientes'">Fechar</RouterLink>
          </div>
        </div>
      </div>
    </div>
  </TrataTecla>

  <Contratos :ClienteId="controle.model.clienteId" />

  <Dependentes :ClienteId="controle.model.clienteId" />

  <Documentos :ClienteId="controle.model.clienteId" />

  <Vouchers :ClienteId="controle.model.clienteId" />

  <MsgBox :id="'janAlterarSenha'" :titulo="'Alterar Senha'" :tamanho="'modal-sm'" :exibir="controle.janAlterarSenha"
    @onFechou="controle.janAlterarSenha = false" :botao-gravar="true" :botao-fechar="true"
    @onGravar="confirmarAlterarSenha()">
    <div class="row">
      <div class="col-md-12 fw-bold fs-6 mb-3">
        {{ controle.model.nome }}
      </div>
      <div class="col-md-12 mb-2">
        <label>Senha</label>
        <input type="password" class="form-control form-control-sm" v-model="controle.formSenha.senhaNova" />
      </div>
      <div class="col-md-12">
        <label>Confirmar Senha</label>
        <input type="password" class="form-control form-control-sm" v-model="controle.formSenha.confirmaNovaSenha" />
      </div>

      <div class="col-md-12 mt-2">
        <div class="alert alert-danger" v-if="controle.erro">{{ controle.erro }}</div>
        <div class="alert alert-success" v-if="controle.status">{{ controle.status }}</div>
      </div>
    </div>
  </MsgBox>
</template>